import axios from "axios";

export const faqData = () => {
  return axios
    .get("/faqs")
    .then((response) => {
      // console.log(response.data);
      return response;
    });
};